<template>
  <div class="mx-auto">
    <div class="clearfix">
      <div class="float-left">
        <div> <span class="title bolder">능력단위 요소명: </span>{{bank.unitName}}</div>
        <div> <span class="title bolder">능력단위 요소 코드: </span>{{bank.unitCode}}</div>
        <div> <span class="title bolder">문항수: </span>총{{bank.questions.length}} 문제</div>
      </div>
      <div class="float-right text-right">
        <mdb-btn icon="undo" class="p-2" color="primary" @click="$emit('mode-change')">문제은행 목록</mdb-btn>
        <mdb-btn icon="save" class="p-2" color="primary" @click="onSave">문제은행 저장</mdb-btn><br>
        <span class="text-pink">문제 은행은 별도로 저장됨</span>
      </div>
    </div>
    <div v-for="(question, qx) in bank.questions" :key="qx" class="mb-5">
      <question-edit :question="question" @delete-question="onDeleteQeustion(qx)"/>
    </div>
    <mdb-btn icon="plus" class="p-2" @click="onAddQuestion">문제 추가</mdb-btn>
  </div>
</template>
<script>
import { } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import QuestionBank from '@/models/QuestionBank'
import QuestionEdit from '../../../../../components/test/QuestionEdit.vue'
export default {
  components: { QuestionEdit },
  name: 'StaffNcsTrainingQuestionBankEdit',
  props: ['bank'],
  data: () => ({
    TAG: 'StaffNcsTrainingQuestionBankEdit'
  }),
  methods: {
    onBack () {
      this.$router.back()
    },
    onDeleteQeustion (qx) {
      if (!confirm('문제를 삭제할까요?')) return
      this.bank.questions.splice(qx, 1)
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      this.bank.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      this.bank.delete()
    },
    onAddQuestion () {
      this.bank.questions.push({})
    }
  },
  created () {
    if (!this.bank) {
      this.bank = {}
    }
  }

}
</script>
